export const detailRoutes = {
    // add additional detail routes here
};
